import Axios, { AxiosResponse } from 'axios';
import { ActionT } from '../../framework/framework/components/Types';
import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import { IModelOpinion } from '../../pages/productCard/dataModels/ProductModels';

import Emitter from '../eventEmmiter/EventEmmiter';
import { EventTypes } from '../eventEmmiter/EventTypes';

export class ProductService {
    static instance: ProductService;

    static Instance() {
        return ProductService.instance;
    }

    static appCtx: ApplicationContext;

    static init(appCtx: ApplicationContext) {
        ProductService.appCtx = appCtx;
        ProductService.instance = new ProductService();
    }

    axios = Axios;

    get appCtx() { return ProductService.appCtx; }

    public getProductData(url: string, onDataChanged: ActionT<any>): any {
        this.axios.get(url)
            .then(response => { onDataChanged(response.data); })
            .catch(error => { this.onError(error); });
    }

    onError(error: any) {
        if (error.response.status === 404) {
            if (error.response.data && error.response.data.redirectUrl) {
                const url = this.appCtx.buildUrl(error.response.data.redirectUrl);
                window.location.href = url;
            }
        }
    }

    addToBasket(productId: number, name:string, quantity: number) {
        const data = {
            productId: productId,
            quantity: quantity
        };
        const url = this.appCtx.buildUrl('Basket/AddItemToBasket');
        this.axios.post(url, data)
            .then(() => {
                Emitter.emit(EventTypes.Shopping, null);
                Emitter.emit(EventTypes.Message, `Produkt ${name} został dodany do koszyka`);
            })
            .catch(error => {
                console.log(error);
            });
    }

    addReview(r: IModelOpinion):Promise<AxiosResponse<any>> {
        const url = this.appCtx.buildUrl('Product/AddReview');
        return this.axios.post(url, r);
    }
}
